import React from "react";
import FooterLink from "./FooterLink";

interface Link {
    name: string;
    url: string;
    external: boolean;
}

interface DesktopFooterContentProps {
    supportLinks: Link[];
    legalLinks: Link[];
}

/**
 * Desktop footer content with grid layout
 */
const DesktopFooterContent = ({ supportLinks, legalLinks }: DesktopFooterContentProps) => {
    return (
        <>
            <nav className="block text-left">
                <div className="text-black text-xl font-bold mb-6 pb-[2px] border-b-2 border-black w-[246px]">Support</div>

                {supportLinks.map((link) => (
                    <FooterLink
                        key={link.url}
                        name={link.name}
                        url={link.url}
                        external={link.external}
                        className="mb-[14px] block"
                    />
                ))}

                <p className="font-semibold italic">
                    Monday - Friday 8am - 8pm ET
                    <br />
                    Saturday 11am - 3 pm ET
                </p>
            </nav>

            <nav className="block text-left pt-[54px]">
                {legalLinks.map((link, index) => (
                    <FooterLink
                        key={link.url}
                        name={link.name}
                        url={link.url}
                        external={link.external}
                        className={index === 2 ? "block" : "mb-[14px] block"}
                    />
                ))}
            </nav>

            <nav className="block"></nav>
        </>
    );
};

export default DesktopFooterContent;
